import axios from "axios";

// Empty means "same origin" -- in dev, the craco dev-server proxy forwards
// /api to the backend (see craco.config.js).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  // Without this, a hung connection (backend down, network drop) leaves a
  // caller's `await api.post(...)` pending forever with no error and no
  // success -- e.g. a login button stuck showing "Signing in..." with no
  // way to know anything went wrong. 20s is generous for any real request
  // this app makes; past that, something is actually broken.
  timeout: 20000,
  // X-Requested-With is a lightweight CSRF defense: a plain HTML form can
  // never set a custom header, and a cross-origin script can only attach
  // one if the backend's CORS allow-list permits that origin. See server.py
  // require_csrf_header.
  headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
});

// Attach bearer token from localStorage as fallback (cross-site cookies sometimes blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kn_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  if (err?.code === "ECONNABORTED") return "Request timed out — please check your connection and try again.";
  if (!err?.response) return "Can't reach the server — please check your connection and try again.";
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
